import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  bp,
  flexCenter,
  flexColumn,
  flexSpBetween,
  media,
  rem,
  size,
} from "@styles/Utilities.styled";


export const StyledBilling = styled.section`
  margin-top: 2rem;
  margin-bottom: 8rem;

  .content {
    ${flexColumn}
    gap: 2rem;

    ${media(bp.medium)} {
      flex-direction: row;
      gap: 1.5rem;

      & > div:first-child {
        flex-basis: 30%;
      }
      & > div:last-child {
        flex-basis: 70%;
      }
    }
  }

  .header {
    ${flexSpBetween}
    padding-top: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${alpha("var(--clr-black)", 0.1)};

    h2 {
      font-size: ${rem(20)};
      font-weight: 500;
    }
  }

  .summary-section {
    padding: 1rem 1.5rem 1.5rem;
    height: fit-content;
    min-width: ${rem(350)};
    background-color: var(--clr-white);
    border-radius: var(--border-radius-3);
    border: 1px solid var(--clr-gray-150);

    ${media(bp.medium)} {
      position: sticky;
      top: 1.5rem;
    }
  }

  .details-section {
    padding: 1rem 1.5rem 1.5rem;
    background-color: var(--clr-white);
    border-radius: var(--border-radius-3);
    border: 1px solid var(--clr-gray-150);

    .tab-root {
      height: calc(100% - ${rem(100)});
    }

    .tab {
      height: 100%;
    }

    .form {
      height: 100%;
      gap: 1.5rem;
      /* outline: 1px solid red; */

      &-footer {
        display: flex;
        justify-content: end;
        margin-top: auto;
        padding-top: 1rem;
        border-top: 1px solid ${alpha("var(--clr-black)", 0.1)};
      }
    }

    .empty-label {
      font-size: ${rem(14)};
      color: var(--clr-gray-400);
      margin-top: 2rem;
    }

    .items-list {
      ${flexColumn}
      gap: 0.75rem;
      margin-top: 2rem;

      .item {
        ${flexSpBetween}
        gap: 2rem;
        padding: 0.5rem 1rem;
        border: 1px solid ${alpha("var(--clr-black)", 0.1)};
        border-radius: var(--border-radius-2);

        .wrapper {
          ${alignItemsCenter}
          /* align-items: start; */
          gap: 1rem;
        }

        .icon-wrapper {
          ${flexCenter}
          background-color: var(--clr-primary-100);
          border-radius: var(--border-radius-2);
          min-width: ${rem(50)};
          ${size(rem(50))}

          svg {
            color: var(--clr-primary-400);
            font-size: 1.5rem;
          }
        }

        .text-content {
          ${flexColumn}
          gap: 0.5rem;
        }

        .title {
          font-size: ${rem(14)};
          text-transform: capitalize;

          span {
            text-transform: lowercase;
            color: var(--clr-gray-400);
          }
        }

        .amount-section {
          ${flexColumn}
          align-items: end;

          .amount {
            font-size: ${rem(18)};
            color: var(--clr-primary-400);
            font-weight: 600;
          }
          .date {
            font-size: ${rem(14)};
            color: var(--clr-gray-400);
          }
        }

        .staff-wrapper {
          ${alignItemsCenter}
          gap: 1rem;
          /* outline: 1px solid red; */

          .label {
            font-size: ${rem(14)};
          }
        }

        .staff-list {
          ${alignItemsCenter}
          gap: 0.25rem;

          &-item {
            background-color: var(--pink-3);
            /* background-color: var(--clr-primary-100); */
            color: var(--pink-11);
            font-size: ${rem(13)};
            padding: 0.1em 0.6em;
            border-radius: var(--border-radius-1);
            text-transform: capitalize;
            white-space: nowrap;

            &.service-category {
              color: var(--orange-11);
              background-color: var(--orange-3);
              /* color: var(--clr-primary-700);
              background-color: var(--clr-primary-100); */
            }

            /* &.rejected {
              color: var(--red-11);
              background-color: var(--red-3);
            }

            &.pending {
              color: var(--yellow-11);
              background-color: var(--yellow-3);
            }

            &.paid,
            &.accepted {
              color: var(--green-11);
              background-color: var(--green-3);
            } */

            &.support {
              background-color: var(--blue-3);
              color: var(--blue-11);
            }
          }
        }
      }
    }
  }
`;
